import type { TextareaProps } from '@mantine/core';
import { createStyles, Group, Stack, Textarea } from '@mantine/core';
import { Icon, Text } from '@repo/foundations';
import { memo } from 'react';

const useStyles = createStyles((theme) => ({
	input: {
		padding: 0,
		borderRadius: 0,
		fontFamily:
			'InterDisplay,InterVariable,Inter,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Open Sans","Helvetica Neue",sans-serif',
		fontSize: theme.fontSizes.xl,
		fontWeight: 600,
		lineHeight: theme.other.typography.lineHeight.title.xl,

		'&:focus': {
			boxShadow: 'none',
			borderColor: 'transparent',
			backgroundColor: 'transparent',
		},

		'&:disabled': {
			opacity: 1,
			backgroundColor: theme.other.getColor('fill/transparent/default'),
			color: theme.other.getColor('text/primary/default'),
			cursor: 'text',
		},
	},
}));

export const TitleInput = memo(
	({ error, ...props }: Partial<TextareaProps>) => {
		const { classes } = useStyles();

		return (
			<Stack spacing="xs">
				<Textarea
					classNames={classes}
					data-testid="input-title"
					placeholder="Untitled"
					variant="unstyled"
					autosize
					autoFocus
					size="xl"
					{...props}
				/>
				{error && (
					<Group spacing="2xs">
						<Icon name="alertCircle" color="icon/critical/default" />
						<Text size="sm" color="text/critical/default">
							{error}
						</Text>
					</Group>
				)}
			</Stack>
		);
	}
);
